export default "__VITE_ASSET__b0e7611d__"